import { defineMessages } from 'react-intl';

export default defineMessages({
  sectionTitle: {
    id: 'fastCover.summary.sectionTitle',
    defaultMessage: 'Claim Summary',
  },
  sectionTitleMore: {
    id: 'fastCover.summary.sectionTitleMore',
    defaultMessage: ' (To edit/update any details on a section click on the pencil icon)',
  },
  section0: {
    id: 'fastCover.summary.section0',
    defaultMessage: ' ',
  },
  section1: {
    id: 'fastCover.summary.section1',
    defaultMessage: 'Section 1 - Your Details',
  },
  section2: {
    id: 'fastCover.summary.section2',
    defaultMessage: 'Bank Details',
  },
  section4: {
    id: 'fastCover.summary.section4',
    defaultMessage: 'What Happened',
  },
  section5: {
    id: 'fastCover.summary.section5',
    defaultMessage: 'Trip Cancellation and Additional Expenses',
  },
  section6: {
    id: 'fastCover.summary.section6',
    defaultMessage: 'Personal Items',
  },
  section7: {
    id: 'fastCover.summary.section7',
    defaultMessage: 'Overseas Medical',
  },
  section8: {
    id: 'fastCover.summary.section8',
    defaultMessage: 'Rental Vehicle',
  },
  section9: {
    id: 'fastCover.summary.section9',
    defaultMessage: 'Snow Sports',
  },
  section10: {
    id: 'fastCover.summary.section10',
    defaultMessage: 'Other',
  },
  section11: {
    id: 'fastCover.summary.section11',
    defaultMessage: 'Supporting Documentation',
  },
  section15: {
    id: 'fastCover.summary.section15',
    defaultMessage: 'Claim Summary',
  },
  section18: {
    id: 'fastCover.summary.section18',
    defaultMessage: 'Trip Cancellation & Trip Interruption',
  },
  section19: {
    id: 'fastCover.summary.section19',
    defaultMessage: 'Baggage and Personal Items',
  },
  section20: {
    id: 'fastCover.summary.section20',
    defaultMessage: 'Medical Expenses',
  },
  section21: {
    id: 'fastCover.summary.section21',
    defaultMessage: 'Payment Details',
  },
  section22: {
    id: 'fastCover.summary.section22',
    defaultMessage: 'Bank Details',
  },
  sectionPetMedicalStep: {
    id: 'fastCover.summary.sectionPetMedicalStep',
    defaultMessage: 'Pet Medical',
  },
  sectionCollisionDamageStep: {
    id: 'fastCover.summary.sectionCollisionDamageStep',
    defaultMessage: 'Collision Damage',
  },
  sectionPropertyDamage: {
    id: 'fastCover.summary.sectionPropertyDamage',
    defaultMessage: 'Property Damage',
  },
  sectionTripCancellation: {
    id: 'fastCover.summary.sectionTripCancellation',
    defaultMessage: 'Trip Cancellation',
  },
  sectionMedicalExpenseStep: {
    id: 'fastCover.summary.sectionMedicalExpenseStep',
    defaultMessage: 'Medical Expense',
  },
  sectionAccidentalDeathAndDismemberment: {
    id: 'fastCover.summary.sectionAccidentalDeathAndDismemberment',
    defaultMessage: 'Accidental Death And Dismemberment',
  },
  sectionTripDelayStep: {
    id: 'fastCover.summary.sectionTripDelayStep',
    defaultMessage: 'Trip Delay',
  },
  sectionTripInterruptionStep: {
    id: 'fastCover.summary.sectionTripInterruptionStep',
    defaultMessage: 'Trip Interruption',
  },
  sectionMissedConnectionStep: {
    id: 'fastCover.summary.sectionMissedConnectionStep',
    defaultMessage: 'Missed Connection',
  },
  sectionBaggageAndPersonalStep: {
    id: 'fastCover.summary.sectionBaggageAndPersonalStep',
    defaultMessage: 'Baggage And Personal',
  },
  sectionSportsEquipmentStep: {
    id: 'fastCover.summary.sectionSportsEquipmentStep',
    defaultMessage: 'Sports Equipment',
  },
  sectionMedicalHardshipStep: {
    id: 'fastCover.summary.sectionMedicalHardshipStep',
    defaultMessage: 'Medical Hardship',
  },
  sectionJobLossHardshipStep: {
    id: 'fastCover.summary.sectionJobLossHardshipStep',
    defaultMessage: 'Job Loss Hardship',
  },
  sectionMedicalExpenseCFStep: {
    id: 'fastCover.summary.sectionMedicalExpenseCFStep',
    defaultMessage: 'Medical Expense',
  },
  sectionMedicalExpenseZurichStep: {
    id: 'fastCover.summary.sectionMedicalExpenseZurichStep',
    defaultMessage: 'Medical Expense',
  },
  sectionTripCancellationCFStep: {
    id: 'fastCover.summary.sectionTripCancellationCFStep',
    defaultMessage: 'Trip Cancellation',
  },
  sectionBaggagePersonalEffects: {
    id: 'fastCover.summary.sectionBaggagePersonalEffects',
    defaultMessage: 'Baggage Personal Effects',
  },
  sectionItineraryChange: {
    id: 'fastCover.summary.sectionItineraryChange',
    defaultMessage: 'Itinerary Change',
  },
  readyToSubmit: {
    id: 'fastCover.summary.readyToSubmit',
    defaultMessage: 'Declaration',
  },
  notice: {
    id: 'fastCover.summary.notice',
    defaultMessage: 'Are you sure that you want to export summary PDF?',
  },
  sectionTravelDelay: {
    id: 'fastCover.summary.sectionTravelDelay',
    defaultMessage: 'Travel Delay & Missed Connections',
  },
  sectionMedicalAndEvacuationSCTI: {
    id: 'fastCover.summary.sectionMedicalAndEvacuationSCTI',
    defaultMessage: 'Medical and evacuation',
  },
  sectionChangesToYourJourneySCTI: {
    id: 'fastCover.summary.sectionChangesToYourJourneySCTI',
    defaultMessage: 'Changes to your journey',
  },
  sectionBaggageAndPersonalItemsSCTI: {
    id: 'fastCover.summary.sectionBaggageAndPersonalItemsSCTI',
    defaultMessage: 'Baggage and personal items',
  },
  sectionPersonalAccidentSCTI: {
    id: 'fastCover.summary.sectionPersonalAccidentSCTI',
    defaultMessage: 'Personal Accident',
  },
  sectionRentalVehicleExcessSCTI: {
    id: 'fastCover.summary.sectionRentalVehicleExcessSCTI',
    defaultMessage: 'Rental vehicle excess',
  },
  sectionCashBankCardsTravelDocumentsAndPassports: {
    id: 'fastCover.summary.sectionCashBankCardsTravelDocumentsAndPassports',
    defaultMessage: 'Cash, bank cards, travel documents and passports',
  },
  sectionChangesToYourJourney: {
    id: 'fastCover.summary.sectionChangesToYourJourney',
    defaultMessage: 'Changes to your journey',
  },
  sectionBaggageAndPersonalItemsStarr: {
    id: 'fastCover.summary.sectionBaggageAndPersonalItemsStarr',
    defaultMessage: 'Baggage and personal items',
  },
  sectionOtherStarr: {
    id: 'fastCover.summary.sectionOtherStarr',
    defaultMessage: 'Other',
  },
  sectionCollisionDamageStarr: {
    id: 'fastCover.summary.sectionCollisionDamageStarr',
    defaultMessage: 'Collision Damage',
  },
});



// WEBPACK FOOTER //
// ./app/containers/SummaryScreen/messages.js